module.exports = __webpack_public_path__ + "static/q2-432a5557fb95cceeb0735fcfe2b874ec.png";